export const paymentTypes = {
    HOMESTAYER: 'Homestayer',
    MAINBOOKER: 'Mainbooker',
    FLIGHTS: 'Flights',
    ARRIVALS: 'Arrivals',
    TRAVELLER: 'Traveller'
}
